'use client';
import Link from "next/link";
import { Card } from "@/components/ui/card";
import SchoolImage from "@/components/layout/SchoolImage";
import { trimText } from "@/lib/trimText";

const AcademicCard = ({ item }) => {
  return (
    <Link
      href={`/academics/collections?school=${item?.name}&class=${item?.schoolClass[0]}`}
      aria-label={`View details for ${item?.name}`}
      className="block"
    >
      <Card className="group overflow-hidden rounded-lg border-none shadow-sm ring-1 ring-gray-100 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl">
        <div className="relative aspect-[4/3] w-full overflow-hidden bg-white p-8">
          <SchoolImage
            school={item}
            className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="border-t border-gray-100 bg-gray-50 px-4 py-4 text-center">
          <p className="line-clamp-1 text-sm font-bold tracking-tight text-gray-800 transition-colors group-hover:text-[#0A3982] md:text-base">
            {trimText(item?.name, 28)}
          </p>
        </div>
      </Card>
    </Link>
  );
};

export default AcademicCard;